import React from 'react'
import { slugs } from '@/constants/slugs'
import { getProjectStyle, createContactSupportAnswer } from '../shared'
import { GiveawayFaq } from '../types'

export const getIwasFaqs = (): GiveawayFaq[] => [
  {
    key: 'releaseDate',
    question: (t) => t('giveawayHowDoIenterIwas', 'How do I enter The I Was a Stranger Giveaway?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'IwasReleaseDateAnswers',
          'Just pre-order tickets to I Was a Stranger, in theaters January 9th. Each ticket you buy is an entry—and\n' +
            'the more tickets you buy, the more your entries multiply. Buy early for even bigger multipliers. Both\n' +
            'ways boost your chances to win!',
        )}
      </span>
    ),
  },
  {
    key: 'doIneedTickets',
    question: (t) => t('doINeedTicketsQuestion', 'Do I need to buy tickets to enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'doINeedTicketsAnswer',
          'No. While buying tickets is the easiest way to enter, you can also enter by mail without purchase. See the Official Rules for instructions on free entry options.',
        )}
      </span>
    ),
  },
  {
    key: 'giveawayDates',
    question: (t) => t('seniorWhoCanEnter', 'Who can enter?'),
    answer: (t) => (
      <span className={getProjectStyle(slugs.senior)}>
        {t(
          'seniorWhoCanEnterAnswer',
          'The giveaway is open to legal residents of the 50 United States (excluding NY and FL) and the\n' +
            'District of Columbia, who are at least the age of majority in their state at the time of entry.',
        )}
      </span>
    ),
  },

  {
    key: 'contactSupport',
    question: (t) => t('contactSupportQuestion', 'How do I contact support?'),
    answer: createContactSupportAnswer(slugs.senior),
  },
]
